import 'regenerator-runtime/runtime';
import {SedestralLogic} from "./sedestral/framework/SedestralLogic";
import {Network} from "./network/Network";
import {Panel} from "./products/panel/Panel";
import {PanelNetwork} from "./products/panel/network/PanelNetwork";
import {config} from "./config";
import {ProductName} from "./models/product/ProductName";
import {ProductType} from "./models/product/ProductType";
import Hotjar from '@hotjar/browser';
import {SedestralSsr} from "./sedestral/framework/ssr/SedestralSsr";
import {SedestralProactiveLivechat} from "./sedestral/framework/proactive/livechat/SedestralProactiveLivechat";
import {EntityService} from "./services/entity/EntityService";
import {SedestralProactiveMeta} from "./sedestral/framework/proactive/ads/meta/SedestralProactiveMeta";
import {SedestralProactiveLinkedin} from "./sedestral/framework/proactive/ads/linkedin/SedestralProactiveLinkedin";
import {SedestralProactiveGoogle} from "./sedestral/framework/proactive/analytics/google/SedestralProactiveGoogle";
import {SedestralProactiveLuca} from "./sedestral/framework/proactive/analytics/luca/SedestralProactiveLuca";
import {SiteService} from "./services/site/SiteService";

config.import(ProductName.toString(ProductType.PANEL));
SedestralLogic.ready(async () => {
    await SedestralLogic.init();
    await PanelNetwork.init();
    await Network.init(ProductName.toString(ProductType.PANEL));

    console.log("[WhiteLabel] isWhiteLabel:", config.isWhiteLabel);
    if (config.isWhiteLabel) {
        console.log("[WhiteLabel] Fetching public white label for hostname:", window.location.hostname);
        config.whiteLabelPublic = await SiteService.fetchPublicWhiteLabel(window.location.hostname);
        console.log("[WhiteLabel] API response:", JSON.stringify(config.whiteLabelPublic));
        if (config.whiteLabelPublic) {
            console.log("[WhiteLabel] agencyName:", config.whiteLabelPublic.agencyName);
            console.log("[WhiteLabel] faviconFileId:", config.whiteLabelPublic.faviconFileId);
            if (config.whiteLabelPublic.agencyName) {
                document.title = config.whiteLabelPublic.agencyName;

                const ogSiteName = document.querySelector('meta[property="og:site_name"]') as HTMLMetaElement;
                if (ogSiteName) {
                    ogSiteName.content = config.whiteLabelPublic.agencyName;
                }

                const loaderText = document.querySelector('.globalLoaderBackground .text');
                if (loaderText) {
                    loaderText.textContent = config.whiteLabelPublic.agencyName;
                }
            }
            if (config.whiteLabelPublic.faviconFileId) {
                let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
                const faviconUrl = `${config.httpPanelUrl}/files/${config.whiteLabelPublic.faviconFileId}.png`;
                console.log("[WhiteLabel] Favicon URL:", faviconUrl);
                console.log("[WhiteLabel] Existing <link rel=icon>:", favicon?.href);
                if (favicon) {
                    favicon.href = faviconUrl;
                } else {
                    favicon = document.createElement('link');
                    favicon.rel = 'icon';
                    favicon.href = faviconUrl;
                    document.head.appendChild(favicon);
                }
                console.log("[WhiteLabel] Favicon set to:", favicon.href);
            } else {
                console.log("[WhiteLabel] No faviconFileId in response");
            }
        } else {
            console.log("[WhiteLabel] API returned null/undefined");
        }
    }

    await Panel.init();

    if (!SedestralSsr.hasSsr() && !/Googlebot|Spiders|Crawlers/i.test(navigator.userAgent)) {
        if (!config.isDev && !config.isWhiteLabel) {
            try {
                const hotJarId = config.hotjarPanelId;
                const hotJarVersion = 6;
                Hotjar.init(Number(hotJarId), hotJarVersion);
            } catch (e) {
                console.error(e);
            }
        }

        SedestralProactiveMeta.init();
        SedestralProactiveLinkedin.init();
        SedestralProactiveGoogle.init();
        SedestralProactiveLuca.init();
        await SedestralProactiveLivechat.init(true);
        if (EntityService.activeEntity) {
            SedestralProactiveLivechat.setUserName(EntityService.activeEntity?.name);
            SedestralProactiveLivechat.setUserEmail(EntityService.activeEntity?.email);
            // Le rattachement se fait sur le site : c'est la seule cle que Stripe nous rend
            // cote back (metadonnee siteId de l'abonnement) au moment de remonter le paiement.
            if (EntityService.activeEntity.siteId) {
                SedestralProactiveLuca.identify(EntityService.activeEntity.siteId);
            }
        }
    }
})
;